import React, {useEffect, useRef, useState} from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Label from 'reactstrap/lib/Label';
import {getLanguage, t} from 'react-switch-lang';
import SelectInfinite from '../../../../components/FormFields/SelectInfinite';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {DepartmentScheme} from '../scheme';
import "./Form.scss";
import {updatedepartment} from '../../../../services/departmentService';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import InputText from '../../../../components/FormFields/InputText';
import SelectList from '../../../../components/select/SelectList';
import {appModuleIdsOptions} from './departmentFormOptions';

const PreviewDepartment = (props) => {
  const {
    name,
    nameEn,
    departmentTypeId,
    departmentTypeName,
    departmentTypeNameEn,
    parentId,
    parentName,
    parentNameEn,
    userResponsibleId,
    userResponsibleFullName,
    userInChargeId,
    userInChargeFullName,
    userInChargeReplacementId,
    userInChargeReplacementFullName,
    sectorDirectorId,
    sectorDirectorFullName,
    userInChargeForExternalizationId,
    userInChargeForExternalizationFullName,
    deputyUserInChargeForExternalizationId,
    deputyUserInChargeForExternalizationFullName,
    userResponsibleForExternalizationId,
    userResponsibleForExternalizationFullName,
    appModuleIds
  } = props.data
  const [departmentTypes, setDepartmentTypes] = useState({
    value: departmentTypeId,
    label: getLanguage() === 'eng' ? departmentTypeNameEn : departmentTypeName,
  });
  const [parentIdValue, setParentIdValue] = useState(parentId !== null ?{
    value: parentId,
    label: getLanguage() === 'eng' ? parentNameEn : parentName,
  } : null);
  const [userResponsibleIdValue, setUserResponsibleId] = useState(userResponsibleId !== null ? {
    value: userResponsibleId,
    label: userResponsibleFullName,
  } : null);
  const [userInChargeIdValue, setUserInChargeId] = useState(userInChargeId !== null ? {
    value: userInChargeId,
    label: userInChargeFullName,
  } : null);
  const [userInChargeReplacementIdValue, setUserInChargeReplacementId] = useState(userInChargeReplacementId !== null ? {
    value: userInChargeReplacementId,
    label: userInChargeReplacementFullName,
  } : null);
  const [sectorDirectorIdValue, setSectorDirectorId] = useState(sectorDirectorId !== null ? {
    value: sectorDirectorId,
    label: sectorDirectorFullName,
  } : null);
  const [userResponsibleForExternalizationIdValue, setUserResponsibleForExternalizationId] = useState(userResponsibleForExternalizationId !== null ? {
    value: userResponsibleForExternalizationId,
    label: userResponsibleForExternalizationFullName,
  } : null);
  const [userInChargeForExternalizationIdValue, setUserInChargeForExternalizationId] = useState(userInChargeForExternalizationId !== null ? {
    value: userInChargeForExternalizationId,
    label: userInChargeForExternalizationFullName,
  } : null);
  const [deputyUserInChargeForExternalizationIdValue, setUserInChargeReplacementForExternalizationId] = useState(deputyUserInChargeForExternalizationId !== null ? {
    value: deputyUserInChargeForExternalizationId,
    label: deputyUserInChargeForExternalizationFullName,
  } : null);
  const departmentTypeIdRef = useRef(null);
  const methods = useForm({
    resolver: yupResolver(DepartmentScheme),
  });
  const mappedAppModules = appModuleIdsOptions.filter(option =>
    (appModuleIds ?? []).includes(option?.value)
  );

  useEffect(() => {
    setValue('appModuleIds', mappedAppModules, { shouldValidate: false, shouldDirty: false });
  }, [props?.data]);

  const {handleSubmit, watch, errors, register, setValue} = methods;
  const handleCancel = e => {
    e.preventDefault();
    props.toggleModal();
    props.setDisabled();
  };
  useEffect(() => {
    return () => {
      props.setDisabled();
    };
  }, []);

const submitForm = (data) => {
  const dataToSubmit = {
    id: props?.data?.id,
    name: data?.name,
    nameEn: data?.nameEn,
    departmentTypeId: data?.departmentTypeId?.value,
    parentId: (data?.parentId?.value !== null) ? data?.parentId?.value : null,
    userInChargeId: ( data?.userInChargeId?.value !== null) ? data?.userInChargeId?.value : null,
    userInChargeReplacementId: (data?.userInChargeReplacementId?.value !== null) ? data?.userInChargeReplacementId?.value : null,
    userResponsibleId: (data?.userResponsibleId?.value !== null) ? data?.userResponsibleId?.value : null,
    sectorDirectorId: ( data?.sectorDirectorId?.value !== null) ? data?.sectorDirectorId?.value : null,
    userInChargeForExternalizationId: (data?.userInChargeForExternalizationId?.value !== null) ? data?.userInChargeForExternalizationId?.value : null,
    userResponsibleForExternalizationId: (data?.userResponsibleForExternalizationId?.value !== null) ? data?.userResponsibleForExternalizationId?.value : null,
    deputyUserInChargeForExternalizationId: (data?.deputyUserInChargeForExternalizationId?.value !== null) ? data?.deputyUserInChargeForExternalizationId?.value : null,
    appModuleIds: Array.isArray(data?.appModuleIds)
      ? data?.appModuleIds.map(r => r?.value)
      : [],
  };
  updatedepartment(dataToSubmit).then((res) => {
    if (res.status === 200) {
      Toast.fire({
        title: t('departments.message.updateSuccess', {
          entity: t('departments.department'),
        }),
        icon: 'success',
      });
      props.setRowChanged();
      props.toggleModal();
    }
  }) .catch ((err) => {
    if (err.response.data.detail === 'name') {
      Swal.fire({
        text: `${t('message.departmentExists')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    else if (err.response.data.detail === 'name_en') {
      Swal.fire({
        text: `${t('message.departmentExists')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    else if (err.response.data.code === "module_change_blocked_by_open_externalizations") {
      Swal.fire({
        text: `${t('message.moduleChangeBlockedByOpenExternalization')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    else if (err.response.data.code === "module_change_blocked_by_open_revisions") {
      Swal.fire({
        text: `${t('message.moduleChangeBlockedByOpenRevision')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    else if (err?.response?.data?.code === 'module_change_blocked_by_open_risks') {
      Swal.fire({
        text: `${t('message.moduleChangeBlockedByOpenRisks')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    else {
      Swal.fire({
        text: `${t('message.errorApi')}`,
        icon: 'error',
        confirmButtonText: 'Ok',
      });
    }
  })
};

  useEffect(() => {
    if (errors.departmentTypeId) {
      const select = departmentTypeIdRef.current.select;
      select.focus();
    }
  }, []);

  const nameValue = getLanguage() === "eng" ? "nameEn" : "name";

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="appModuleIds">{t("departments.appModuleIds")}</Label>
            <SelectList
              name="appModuleIds"
              className="select pb-4"
              options={appModuleIdsOptions}
              placeholder={t('departments.placeholder.appModuleIds')}
              isClearable={false}
              isMulti={true}
              defaultValue={mappedAppModules}
              isDisabled={props.disabled}
            />
            <Label for="name"> {t("departments.name")}</Label>
            <InputText
              type="text"
              id="name"
              name="name"
              defaultValue={name}
              className={
                "form-control " +
                (errors.name !== undefined ? "error-field" : "")
              }
              placeholder={t("departments.placeholder.name")}
              disabled={props.disabled}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="nameEn"> {t("departments.nameEn")}</Label>
            <InputText
              type="text"
              id="nameEn"
              name="nameEn"
              defaultValue={nameEn}
              className={
                "form-control " +
                (errors.nameEn !== undefined ? "error-field" : "")
              }
              placeholder={t("departments.placeholder.nameEn")}
              disabled={props.disabled}
            />

          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="departmentTypeId"> {t("departments.departmentTypes")}</Label>
            <SelectInfinite
              api={`/department-types?sort=${nameValue}`}
              labelKey= {getLanguage() === "eng" ? "nameEn" : "name" }
              name="departmentTypeId"
              defaultValue={departmentTypes}
              className={errors.departmentTypeId && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.departmentTypes").toLowerCase()}`}
              queryKeys={"name.contains"}
              isDisabled={props.disabled}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="sectorDirector" className={"labelClass"}>
              {" "}
              {t("departments.sectorDirector")}
            </Label>
            <SelectInfinite
              api={`/users/sector-directors?sort=firstName`}
              name="sectorDirectorId"
              defaultValue={sectorDirectorIdValue}
              className={errors.sectorDirectorValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.placeholder.sectorDirector").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
              isDisabled={props.disabled}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="parentId" className={"labelClass"}> {t("departments.departments")}
              <span className="optional">
                  {t('common.optional')}
                </span></Label>
            <SelectInfinite
              api={`/departments?sort=${nameValue}&id.notEquals=${props?.data?.id}&active.equals=true`}
              labelKey= {getLanguage() === "eng" ? "nameEn" : "name" }
              name="parentId"
              defaultValue={parentIdValue}
              className={errors.parentIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.placeholder.departments").toLowerCase()}`}
              queryKeys={getLanguage() === "eng" ? "nameEn.contains" : "name.contains" }
              isDisabled={props.disabled}

            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userResponsibleId" className={"labelClass"}>
              {" "}
              {t("departments.responsibleUsers")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-responsible-users?sort=firstName`}
              name="userResponsibleId"
              defaultValue={userResponsibleIdValue}
              className={errors.userResponsibleIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.responsibleUsers").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
              isDisabled={props.disabled}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userInChargeId" className={"labelClass"}>
              {" "}
              {t("departments.inChargeUsers")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-in-charge-users?sort=firstName`}
              name="userInChargeId"
              defaultValue={userInChargeIdValue}
              className={errors.userInChargeIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.inChargeUsers").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
              isDisabled={props.disabled}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userInChargeReplacementId" className={"labelClass"}>
              {" "}
              {t("departments.users")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-in-charge-users?sort=firstName`}
              name="userInChargeReplacementId"
              defaultValue={userInChargeReplacementIdValue}
              className={errors.userInChargeReplacementIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.placeholder.users").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
              isDisabled={props.disabled}
            />

          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userResponsibleForExternalizationId" className={"labelClass"}>
              {" "}
              {t("departments.userResponsibleForExternalization")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-responsible-users-for-externalization?sort=firstName`}
              name="userResponsibleForExternalizationId"
              defaultValue={userResponsibleForExternalizationIdValue}
              className={errors.userResponsibleForExternalizationIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.userResponsibleForExternalization").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
              isDisabled={props.disabled}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userInChargeForExternalizationId" className={"labelClass"}>
              {" "}
              {t("departments.userInChargeForExternalization")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-users-in-charge-for-externalization?sort=firstName`}
              name="userInChargeForExternalizationId"
              defaultValue={userInChargeForExternalizationIdValue}
              className={errors.userInChargeForExternalizationIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.userInChargeForExternalization").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
              isDisabled={props.disabled}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="deputyUserInChargeForExternalizationId" className={"labelClass"}>
              {" "}
              {t("departments.userInChargeReplacementForExternalization")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-users-in-charge-for-externalization?sort=firstName`}
              name="deputyUserInChargeForExternalizationId"
              defaultValue={deputyUserInChargeForExternalizationIdValue}
              className={errors.deputyUserInChargeForExternalizationIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.userInChargeReplacementForExternalization").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
              isDisabled={props.disabled}
            />
          </Col>
        </Row>
        {!props.disabled && (
        <Row className="submit-buttons-container mx-0">
          <Col sm={12} className="text-right px-0">
            <div className="submit">
              <button
                className="primary cancel"
                type="reset"
                onClick={(e) => handleCancel(e)}>
                {t("buttons.cancelBtn")}
              </button>
              <button className="primary">
                {t("buttons.saveBtn")}
              </button>
            </div>
          </Col>
        </Row>)}
      </form>
    </FormProvider>
  );
};

export default PreviewDepartment;